<template>
    <tr
        class="vacation-row"
        :class="rowClasses"
    >
        <th class="vacation-row__header" :class="headerClasses" :style="headerStickyStyle">
            <span class="vacation-row__header-text">{{ headerText }}</span>
        </th>
        <td
            v-for="(date, index) in dateList"
            :key="'vac-' + index"
            class="vacation-row__cell"
            :class="cellClasses"
            :style="cellStickyStyle"
        >
            <!-- div + flexbox 구조 -->
            <div class="vacation-list" v-if="getVacationsForDate(date).length > 0">
                <div
                    v-for="vacation in getVacationsForDate(date)"
                    :key="vacation.staffUid"
                    class="vacation-card"
                    :class="getVacationCardClass(vacation.vacationType)"
                >
                    <span class="vacation-card__medical">[{{ getMedicalShort(vacation.medicalName) }}]</span>
                    <span class="vacation-card__name">{{ vacation.staffName || '이름없음' }}</span>
                    <span class="vacation-card__type">{{ getTypeShort(vacation.vacationType) }}</span>
                    <span class="vacation-card__memo">{{ vacation.memo || '' }}</span>
                </div>
            </div>
            <span v-else class="vacation-row__empty">-</span>
        </td>
    </tr>
</template>

<script>
import { VACATION_TYPES } from '@/constants/vacation';

export default {
    name: 'VacationRow',

    props: {
        dateList: {
            type: Array,
            required: true
        },
        vacationMap: {
            type: Map,
            required: true
        },
        dateKeyFormat: {
            type: Function,
            default: (date) => {
                if (typeof date === 'string') {
                    return date.replace(/-/g, '');
                }
                if (date && date.YMD) {
                    return date.YMD.replace(/-/g, '');
                }
                return '';
            }
        },
        sticky: {
            type: Boolean,
            default: true
        },
        stickyTop: {
            type: String,
            default: '40px'
        },
        headerText: {
            type: String,
            default: '연차'
        },
        showFullName: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        rowClasses() {
            return {
                'vacation-row--sticky': this.sticky
            };
        },

        headerStickyStyle() {
            if (this.sticky) {
                return {
                    position: 'sticky',
                    top: this.stickyTop,
                    zIndex: 1001
                };
            }
            return {};
        },

        cellStickyStyle() {
            if (this.sticky) {
                return {
                    position: 'sticky',
                    top: this.stickyTop,
                    zIndex: 1000
                };
            }
            return {};
        },

        headerClasses() {
            return {
                'vacation-row__header--sticky': this.sticky
            };
        },

        cellClasses() {
            return {
                'vacation-row__cell--sticky': this.sticky
            };
        }
    },

    methods: {
        getVacationsForDate(date) {
            const key = this.dateKeyFormat(date);
            return this.vacationMap.get(key) || [];
        },

        getTypeShort(vacationType) {
            const typeMap = {
                [VACATION_TYPES.FULL]: '종',
                [VACATION_TYPES.AM]: '오전',
                [VACATION_TYPES.PM]: '오후'
            };
            return typeMap[vacationType] || vacationType;
        },

        getVacationCardClass(vacationType) {
            return {
                'vacation-card--full': vacationType === VACATION_TYPES.FULL,
                'vacation-card--am': vacationType === VACATION_TYPES.AM,
                'vacation-card--pm': vacationType === VACATION_TYPES.PM
            };
        },

        getMedicalShort(medicalName) {
            if (!medicalName) return '?';
            return medicalName.substring(0, 1);
        }
    }
};
</script>

<style scoped>
.vacation-row {
    background-color: #ffffff;
}

.vacation-row--sticky {
    position: sticky;
}

.vacation-row__header {
    font-weight: 600;
    text-align: center;
    padding: 8px;
    width: 100px;
    min-width: 100px;
    background-color: #fbbf24;
    border: 1px solid rgba(0, 0, 0, 0.08);
    vertical-align: middle;
    color: #78350f;
}

.vacation-row__header--sticky {
    position: sticky;
    left: 0;
    z-index: 1001;
    background-color: #fbbf24;
}

.vacation-row__header-text {
    font-size: 12px;
    font-weight: 600;
}

.vacation-row__cell {
    padding: 0;
    vertical-align: top;
    border: 1px solid rgba(0, 0, 0, 0.08);
    background-color: #ffffff;
}

.vacation-row__cell--sticky {
    background-color: #ffffff;
}

.vacation-row__empty {
    display: block;
    padding: 8px;
    color: #d1d5db;
    font-size: 12px;
    text-align: center;
}

/* 연차 리스트 컨테이너 */
.vacation-list {
    display: flex;
    flex-direction: column;
    text-align: left;
}

/* 연차 카드 - flexbox */
.vacation-card {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-align: left;
    padding: 8px;
    font-size: 12px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.vacation-card:last-child {
    border-bottom: none;
}

.vacation-card:hover {
    background-color: rgba(251, 191, 36, 0.2);
}

/* 연차 유형별 색상 */
.vacation-card--full {
    background-color: #fee2e2;
}

.vacation-card--full:hover {
    background-color: #fecaca;
}

.vacation-card--am {
    background-color: #fef9c3;
}

.vacation-card--am:hover {
    background-color: #fef08a;
}

.vacation-card--pm {
    background-color: #e0e7ff;
}

.vacation-card--pm:hover {
    background-color: #c7d2fe;
}

/* 카드 내 요소 */
.vacation-card__medical {
    width: 30px;
    flex-shrink: 0;
    font-weight: 600;
    color: #059669;
}

.vacation-card__name {
    width: 60px;
    flex-shrink: 0;
    font-weight: 600;
    color: #1f2937;
    margin-right: 8px;
}

.vacation-card__type {
    width: 30px;
    flex-shrink: 0;
    color: #78350f;
}

.vacation-card__memo {
    flex: 1;
    color: #6b7280;
    font-size: 11px;
    margin-left: 4px;
}
</style>
